export const DEFAULT_FRAMING = Object.freeze({ focalX: 0.5, focalY: 0.5, zoom: 1 });
export const PHOTO_FIELDS = Object.freeze({ avatar: 'profilePhoto', cover: 'coverPhoto' });
export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export function getPhotoBinding(player, target) {
  const field = PHOTO_FIELDS[target];
  return { sourceUrl: player?.[field] || '', sourceVersion: player?.[`${field}Version`] || 0 };
}

export function getSavedFraming(player, target) {
  const binding = getPhotoBinding(player, target);
  const adjustment = player?.[`${PHOTO_FIELDS[target]}Adjustment`];
  if (!adjustment || adjustment.sourceUrl !== binding.sourceUrl ||
      adjustment.sourceVersion !== binding.sourceVersion ||
      ![adjustment.focalX, adjustment.focalY, adjustment.zoom].every(Number.isFinite) ||
      adjustment.focalX < 0 || adjustment.focalX > 1 || adjustment.focalY < 0 ||
      adjustment.focalY > 1 || adjustment.zoom < 1 || adjustment.zoom > 3) return DEFAULT_FRAMING;
  return { focalX: adjustment.focalX, focalY: adjustment.focalY, zoom: adjustment.zoom };
}

export function isPositionableImage(source) {
  try {
    const url = new URL(source);
    return ['https:', 'http:'].includes(url.protocol) &&
      !/(^|\.)youtu(?:be\.com|\.be)$/i.test(url.hostname) &&
      !/\.(mp4|webm|ogg|mov|m4v)(?:$|\/)/i.test(url.pathname) &&
      !url.pathname.includes('/video/upload/');
  } catch (_) { return false; }
}

// Focal coordinates belong to the source image, not to any one screen size.
export function getPhotoPlacement(image, viewport, framing = DEFAULT_FRAMING) {
  if (!image?.width || !image?.height || !viewport?.width || !viewport?.height) return null;
  const scale = Math.max(viewport.width / image.width, viewport.height / image.height) * framing.zoom;
  const width = image.width * scale;
  const height = image.height * scale;
  return {
    width, height,
    left: clamp(viewport.width / 2 - framing.focalX * width, viewport.width - width, 0),
    top: clamp(viewport.height / 2 - framing.focalY * height, viewport.height - height, 0),
  };
}

export function movePhoto(placement, viewport, deltaX, deltaY, zoom) {
  return {
    focalX: clamp((viewport.width / 2 - placement.left - deltaX) / placement.width,
      viewport.width / (2 * placement.width), 1 - viewport.width / (2 * placement.width)),
    focalY: clamp((viewport.height / 2 - placement.top - deltaY) / placement.height,
      viewport.height / (2 * placement.height), 1 - viewport.height / (2 * placement.height)),
    zoom,
  };
}
